import React, { useCallback, useState } from 'react';
import * as S from './styles';

interface Props {
  activeTab?: number;
  onTabChange?: (index: number) => void;
  children: Array<React.ReactNode>;
}

export const Controller: React.FC<Props> = ({
  activeTab,
  onTabChange,
  children,
}) => {
  const [internalActiveTab, setInternalActiveTab] = useState<number>(0);
  const selectedIndex = activeTab ?? internalActiveTab;
  const BASE_CLASS = 'tab-button';

  const handleTabChange = useCallback(
    (index: number): void => {
      if (activeTab === undefined) setInternalActiveTab(index);
      onTabChange?.(index);
    },
    [activeTab, onTabChange]
  );

  return (
    <S.Controller>
      {children.map((child, index) => {
        return (
          <S.ControllerButton
            key={index}
            className={
              index === selectedIndex ? `${BASE_CLASS} active` : BASE_CLASS
            }
            onClick={() => handleTabChange(index)}
            type="button"
            aria-pressed={index === selectedIndex}
          >
            {child}
          </S.ControllerButton>
        );
      })}
    </S.Controller>
  );
};
